const $popup = {
    container: $(".c-popup"),
    close: $(".c-popup .js-close"),
}

const popupActiveValue = sessionStorage.getItem('popupActive');

if (popupActiveValue == null && popupActiveValue !== false && $popup.container.length > 0) {

    $(document).ready(function () {

        setTimeout(function () {
            $popup.container.addClass('js-isActive');
        }, 500);
    });

    $popup.close.click(function () {
        $popup.container.removeClass('js-isActive');
        sessionStorage.setItem('popupActive', false);
    });
}

